import React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

const PoliticaCookies = () => (
  <Layout>
    <Seo title="Política de cookies" />

    <div className="page-legal container">
      <h1 className="title">Política de cookies</h1>

      <p className="legal-subtitle">
        ¿QUÉ SON LAS COOKIES Y CÓMO LAS UTILIZA EL SITIO WEB DE Brokalia?
      </p>

      <p>
        Las Cookies son archivos que el Sitio web o la aplicación que utiliza
        instala en su navegador o en su dispositivo (Smartphone, tableta o
        televisión conectada) durante su recorrido por las páginas o por la
        aplicación, y sirven para almacenar información sobre su visita. Como la
        mayoría de los sitios en internet, el portal web de Brokalia utiliza
        Cookies para:
      </p>

      <ul>
        <li>Asegurar que las páginas web pueden funcionar correctamente</li>
        <li>
          Almacenar sus preferencias, como el idioma que ha seleccionado o el
          tamaño de letra
        </li>
        <li>Conocer su experiencia de navegación</li>
        <li>
          Recopilar información estadística anónima, como qué páginas ha visto o
          cuánto tiempo ha estado en nuestros medios
        </li>
      </ul>

      <p>
        El uso de Cookies nos permite optimizar su navegación, adaptando la
        información y los servicios ofrecidos a sus intereses, para
        proporcionarle una mejor experiencia siempre que nos visite. El Sitio
        web de Brokalia utiliza Cookies para funcionar, adaptar y facilitar al
        máximo la navegación del Usuario.
      </p>

      <p>
        Las Cookies se asocian únicamente a un usuario anónimo y su
        ordenador/dispositivo y no proporcionan referencias que permitan conocer
        datos personales. En todo momento podrá acceder a la configuración de su
        navegador para modificar y/o bloquear la instalación de las Cookies
        enviadas por el Sitio web de Brokalia, sin que ello impida al acceso a
        los contenidos. Sin embargo, la calidad del funcionamiento de los
        servicios puede verse afectada.
      </p>

      <p>
        Los Usuarios que completen el proceso de registro o hayan iniciado
        sesión con sus datos de acceso podrán acceder a servicios personalizados
        y adaptados a sus preferencias según la información personal
        suministrada en el momento del registro y la almacenada en la Cookie de
        su navegador.
      </p>
      <p>
        Las herramientas de email-marketing de Brokalia utilizan pequeñas
        imágenes invisibles para los usuarios que son incluidas en los emails.
        Esta tecnología nos permite saber si un email se ha leído o no, en qué
        fecha, la dirección IP desde la que ha sido consultado, etc. Con esta
        información, realizamos estudios estadísticos y analíticos sobre el
        envío y recepción de los emails para mejorar la oferta de los servicios
        a los que el usuario está suscrito y ofrecerle información que pueda ser
        de su interés.
      </p>

      <p className="legal-subtitle">¿POR QUÉ SON IMPORTANTES LAS COOKIES?</p>

      <ul>
        <li>
          Desde un punto de vista técnico, permiten que el Sitio web funcione de
          forma más ágil y adaptada a las preferencias de los usuarios, como por
          ejemplo almacenar el idioma, la moneda del país o detectar el
          dispositivo de acceso.
        </li>
        <li>
          Establecen niveles de protección y seguridad que impiden o dificultan
          ciberataques contra el Sitio web o sus usuarios.
        </li>
        <li>
          Permiten que los gestores de los medios puedan conocer datos
          estadísticos recopilados en las Cookies para mejorar la calidad y
          experiencia de sus servicios.
        </li>
        <li>
          Sirven para optimizar la publicidad que mostramos a los usuarios,
          ofreciendo la que más se ajusta a sus intereses.
        </li>
      </ul>

      <p className="legal-subtitle">
        ¿QUÉ TIPO DE COOKIES UTILIZAMOS EN Brokalia?
      </p>

      <ol>
        <li>
          Cookies “analíticas”: Con propósitos de mantenimiento periódico, y en
          aras de garantizar el mejor servicio posible al usuario, este sitio
          web hace uso de cookies “analíticas” para el recabado de estadísticas
          de actividad. La información recabada será en todo caso anónima, no
          siendo posible establecer vínculo alguno entre patrones de navegación
          y personas físicas. El usuario podrá excluir su actividad individual
          mediante los sistemas de exclusión facilitados por los propios
          proveedores de los sistemas de análisis que utilizan estas cookies,
          como Google Analytics. Es posible que esta web utilice varios de
          dichos sistemas, y puede consultar la lista completa en el listado de
          cookies al final de este documento.
        </li>
        <li>
          Otras cookies de uso interno: Además, esta web puede usar diversas
          cookies para el mantenimiento de sesiones de usuario entre diferentes
          “logins” a las áreas privadas o de autogestión facilitadas. Su
          desactivación ocasiona normalmente molestias al usuario en forma de
          funcionalidades bloqueadas, y son por tanto cookies necesarias para el
          funcionamiento de este sitio. Nuevamente, puede consultar la lista
          completa en el listad de cookies al final de este documento.
        </li>
        <li>
          Cookies usadas por redes sociales: Además, en la medida en que se hace
          uso de Social Plugins, esta web puede participar de distintas redes
          sociales, como por ejemplo Facebook, para permitir que el usuario
          pueda compartir con su círculo social aquellos contenidos que le
          resulten de interés. En la lista de cookies al final de este
          documento, se pueden comprobar las cookies instaladas y las redes
          sociales correspondientes.
        </li>
        <li>
          Cookies usadas por complementos externos de contenido: Esta web puede
          hacer uso de complementos de visualización de contenido, como por
          ejemplo Google Maps para visualizar ubicaciones geográficas. Su uso
          implica en ocasiones la remisión de ciertas cookies que son detalladas
          en el listado al final del documento. Algunas de estas cookies son
          instaladas y gestionadas por los proveedores de dichos complementos,
          no pudiendo ser accedidas por esta sitio web.
        </li>
        <li>
          Cookies de terceros para la personalización de espacios publicitarios:
          Esta web puede hacer uso de ad servers y, por ende, cookies vinculadas
          a los mismos para la elaboración de perfiles a partir de preferencias
          y comportamiento. En caso de hacerlo, las mismas se detallarán en el
          listado al final de este documento, no siendo instaladas si, tras ser
          informado al acceder al sitio, el usuario no acepta la política de
          cookies y por tanto no continúa su navegación.
        </li>
      </ol>

      <p className="legal-subtitle">
        RELACIÓN Y DESCRIPCIÓN DE COOKIES. NIVELES DE INTRUSION:
      </p>
      <p>
        La tabla que aquí sigue esquematiza las cookies arriba expuestas,
        incorporando un criterio de “nivel de intrusión” apoyado en una escala
        del 1 al 3, en la que:
      </p>
      <p>
        <strong>Nivel 1:</strong> se corresponde con cookies de uso interno
        imprescindibles para el funcionamiento del sitio web y, por tanto, la
        prestación del servicio solicitado por el usuario, así como cookies
        gestionadas por terceros con la única finalidad de permitir el correcto
        funcionamiento de complementos externos de contenido y, por tanto,
        necesarias para la correcta visualización de este sitio web.
      </p>
      <p>
        <strong>Nivel 2:</strong> se corresponde con cookies anónimas,
        analíticas, de uso interno, necesarias para el mantenimiento de
        contenidos y navegación, y exclusivamente gestionadas por este sitio
        web.
      </p>
      <p>
        <strong>Nivel 3:</strong> se corresponde con cookies gestionadas por
        terceros que permiten el seguimiento del usuario a través de otras webs
        o servicios.
      </p>

      <p className="legal-subtitle">
        TABLA DE COOKIES USADAS EN ESTE SITIO WEB, INDICANDO EL GESTOR DE LAS
        MISMAS CUANDO ES UN TERCERO
      </p>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Cookie</th>
            <th>Duración</th>
            <th>Propósito</th>
            <th>Intrusividad</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>sessionid</td>
            <td>1 mes</td>
            <td>
              Cookie propia. Mantenimiento de la sesión de usuario a lo largo de
              la web y formularios
            </td>
            <td>nivel 1</td>
          </tr>
          <tr>
            <td>__utma</td>
            <td>2 años</td>
            <td>
              Cuando este usuario vuelva a entrar en nuestra página con el mismo
              navegador, la cookie considerará que es el mismo usuario. Solo en
              el caso de que el usuario cambie de navegador, Google Analytics lo
              considerará otro usuario
            </td>
            <td>nivel 2</td>
          </tr>
          <tr>
            <td>__utmb</td>
            <td>30 minutos</td>
            <td>
              Medición interna con Google Analytics. Habilita la función de
              cálculo del tiempo de sesión. Registra la hora de entrada en la
              página.
            </td>
            <td>nivel 2</td>
          </tr>
          <tr>
            <td>__utmc</td>
            <td>De sesión</td>
            <td>
              Medición interna con Google Analytics. Habilita la función de
              cálculo del tiempo de sesión. Comprueba si se debe mantener la
              sesión abierta o se debe crear una sesión nueva. Se elimina
              automáticamente al cambiar de web o al cerrar el navegador.
            </td>
            <td>nivel 2</td>
          </tr>
          <tr>
            <td>__utmz</td>
            <td>6 meses</td>
            <td>
              Medición interna con Google Analytics. Habilita la función de
              registro de la procedencia del usuario. Los datos registrados
              serán, entre otros, si el usuario llega a nuestro Website por
              tráfico directo, desde otra web, desde una campaña publicitaria o
              desde un buscador (indicando la palabra clave utilizada y la
              fuente)
            </td>
            <td>nivel 2</td>
          </tr>
        </tbody>
      </table>

      <p className="legal-subtitle">
        ¿CÓMO PUEDO DESACTIVAR O ELIMINAR ESTAS COOKIES?
      </p>

      <p>
        El usuario podrá en cualquier momento elegir qué cookies quiere que
        funcionen en este sitio web mediante, por ejemplo, la configuración del
        navegador:
      </p>

      <ul>
        <li>
          Para más información sobre Microsoft Internet Explorer{" "}
          <a
            href="http://windows.microsoft.com/es-419/internet-explorer/delete-manage-cookies#ie=ie-11"
            target="_blank"
            rel="noopener noreferrer"
          >
            pulse aquí
          </a>
        </li>
        <li>
          Para más información sobre Mozilla Firefox{" "}
          <a
            href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we#w_lcahmo-cambio-la-configuraciahn-de-las-cookies"
            target="_blank"
            rel="noopener noreferrer"
          >
            pulse aquí
          </a>
        </li>
        <li>
          Para más información sobre Google Chrome{" "}
          <a
            href="https://support.google.com/accounts/answer/61416?hl=es"
            target="_blank"
            rel="noopener noreferrer"
          >
            pulse aquí
          </a>
        </li>
        <li>
          Para más información sobre Safari{" "}
          <a
            href="https://support.apple.com/es-es/guide/safari/sfri11471/mac"
            target="_blank"
            rel="noopener noreferrer"
          >
            pulse aquí
          </a>
        </li>
      </ul>

      <p className="legal-subtitle">
        QUÉ OCURRE SI SE DESHABILITAN LAS COOKIES
      </p>
      <p>Algunas funcionalidades de los Servicios quedarán deshabilitadas. </p>

      <p className="legal-subtitle">
        ACTUALIZACIÓN DE NUESTRA POLÍTICA DE COOKIES
      </p>
      <p>
        Es posible que actualicemos la Política de Cookies de nuestro Sitio web,
        por ello le recomendamos revisar esta política cada vez que acceda al
        mismo con el objetivo de estar adecuadamente informado sobre cómo y para
        qué usamos las cookies.{" "}
      </p>
    </div>
  </Layout>
)

export default PoliticaCookies
